import toyotaCare from 'features/toyota-care';

export default {
  toyotaCare: toyotaCare,
};
